import { DictionaryController } from '@/controllers/Dictionary';
import { ReduxSagaAction } from '@/types';

import { DictionariesActionTypes } from './action-types';
import * as selectors from './selectors';

export const fetchPossibleOrderStatuses = (useCache = true): ReduxSagaAction => ({
  type: DictionariesActionTypes.FETCH_POSSIBLE_ORDER_STATUSES.START,
  subtypes: DictionariesActionTypes.FETCH_POSSIBLE_ORDER_STATUSES,
  sagaPayload: { dictionaryName: 'orderStatuses' },
  selector: useCache ? selectors.selectPossibleOrderStatuses : undefined,
  promise: () => DictionaryController.fetchOrderDictionary('statuses'),
});

export const fetchProposalItems = (proposalId: string): ReduxSagaAction => ({
  type: DictionariesActionTypes.FETCH_PROPOSAL_ITEMS.START,
  subtypes: DictionariesActionTypes.FETCH_PROPOSAL_ITEMS,
  sagaPayload: { dictionaryName: 'proposalItems' },
  promise: () => DictionaryController.fetchProposalItems(proposalId),
});

export const fetchRequestNewProposalReasons = (useCache = true): ReduxSagaAction => ({
  type: DictionariesActionTypes.FETCH_REQUEST_NEW_PROPOSAL_REASONS.START,
  subtypes: DictionariesActionTypes.FETCH_REQUEST_NEW_PROPOSAL_REASONS,
  selector: useCache ? selectors.selectRequestNewProposalReasons : undefined,
  promise: DictionaryController.fetchRequestNewProposalReasons,
});
